/* eslint-disable */
export default {
  pages: {
    key: "title",
    data: [
      // DASHBOARDS
      { title: "Analytics Dashboard", url: "/dashboard/analytics", icon: "HomeIcon", is_bookmarked: false },
      { title: "eCommerce Dashboard", url: "/dashboard/ecommerce", icon: "HomeIcon", is_bookmarked: false },

      // APPS
      { title: "Organisation List", url: "/organisation/list", icon: "ListIcon", is_bookmarked: false },
      { title: "Store List", url: "/store/list", icon: "ListIcon", is_bookmarked: false },
      // PAGES
      { title: "Login Page", url: "/login", icon: "LockIcon", is_bookmarked: false },
      { title: "Register Page", url: "/register", icon: "UserPlusIcon", is_bookmarked: false },
      { title: "Forgot Password Page", url: "/forgot-password", icon: "HelpCircleIcon", is_bookmarked: false },
      { title: "Reset Password Page", url: "/pages/reset-password", icon: "UnlockIcon", is_bookmarked: false },
      { title: "Lock Screen Page", url: "/pages/lock-screen", icon: "LockIcon", is_bookmarked: false },
      { title: "Coming Soon Page", url: "/comingsoon", icon: "ClockIcon", is_bookmarked: false },
      { title: "404 Page", url: "/error-404", icon: "MonitorIcon", is_bookmarked: false },
      { title: "500 Page", url: "/error-500", icon: "MonitorIcon", is_bookmarked: false },
      { title: "Not Authorized Page", url: "/pages/not-authorized", icon: "XCircleIcon", is_bookmarked: false },
      { title: "Maintenance Page", url: "/pages/maintenance", icon: "MonitorIcon", is_bookmarked: false },
      { title: "Profile Page", url: "/pages/profile", icon: "UserIcon", is_bookmarked: false },
      { title: "User Settings", url: "/pages/user-settings", icon: "SettingsIcon", is_bookmarked: false },
      { title: "FAQ Page", url: "/pages/faq", icon: "HelpCircleIcon", is_bookmarked: false },
      { title: "KnowledgeBase Page", url: "/pages/knowledge-base", icon: "BookIcon", is_bookmarked: false },
      { title: "Search Page", url: "/pages/search", icon: "SearchIcon", is_bookmarked: false },
    ]
  }
}
/* eslint-enable */
